module.exports = __webpack_public_path__ + "static/media/25th Avenue, San Francisco, CA2.a512e519.jpg";